import '../App.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Rating from './Rating';

export default function Book({book, addToCart}) {
    let id = book.id;
    let title = book.title;
    let image = book.image;
    let author = book.author;
    let rating = book.rating;
    let price = book.price;
    
    const [added, setAdded] = useState(false);
    
    const handleClick = () => {
        addToCart(book);
        if (!added) setAdded(true);
    }
    return (
        <div className='book-container' key={id}>
            <Link to={`/products/${id}`} className='book-link'>
                <img src={image} alt={title} />
                <p className='book-title'>{title}</p>
                <p className='book-author'>By {author}</p>
                <Rating classes={''} rating={rating}></Rating>
                <p className='book-price'>${price.toFixed(2)}</p>
            </Link>
            <button onClick={() => handleClick()} className={(added ? 'added' : '')}>{added ? 'Added': 'Add To Cart'}</button>
        </div>
    )

}
